<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-02 14:55:07
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-15 20:02:23
-->
<template>
	<div>
		<el-drawer title="交接详情" :visible.sync="drawer" class="handover" :wrapperClosable="false" @closed="handleClose" ref="drawer" size="800px">
			<div class="content">
				<div class="font-h4-regular yx-color-text-primary bgcf radius-8 pt-20">
					<div class="title-line pb-18 yx-pingfang-Medium"> 基础信息 </div>
					<div class="flex-row">
						<div class="mr-20">
							<div class="flex-row">
								<div class="color-gy-7" style="width: 100px">操作人</div>
								<div> {{ row.operator_name }}</div>
							</div>
							<div class="flex-row flex-align-center mt-2 mb-2">
								<div class="color-gy-7" style="width: 100px"> 被移交人 </div>
								<div class="flex-row flex-align-center">
									<div class="mr-4">{{ row.from_user_name }}</div>
									<tag class="ml-6 mt-2" :content="item" v-for="(item, index) in row.from_user_type" :key="index" />
								</div>
							</div>
							<div class="flex-row flex-align-center">
								<div class="color-gy-7" style="width: 100px">新移交人</div>
								<div class="flex-row flex-align-center">
									<div class="mr-4">{{ row.to_user_name }}</div>
									<tag class="ml-6 mt-2" :content="item" v-for="(item, index) in row.to_user_type" :key="index" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="middle bgcf radius-8 mt-24 pt-20">
					<div class="title-line pb-18 yx-pingfang-Medium"> 详细信息 </div>
					<div class="table gray-table-header">
						<multi-table
							:stickyHeader="false"
							v-loading="loading"
							ref="multiTable"
							:columns="tableLabel"
							@gePartnerList="gePartnerList"
							:page="pageInfo"
							:list="list"
							:total="total"
						>
							<empty slot="empty">
								<div slot="desc">暂无待移交{{ emptyText }}</div>
							</empty>
						</multi-table>
					</div>
				</div>
			</div>
			<div class="footer yx-background-white flex-row-align-center flex-just-end">
				<div>
					<el-button @click="handleClose">关 闭</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import Tag from '@/components/ui/tag';
import { relayAnchorDetail } from '@/api/teamManage';
import columns from './columns';
import empty from '@/views/common/empty/index.vue';
export default {
	components: {
		Tag,
		empty,
	},
	computed: {
		isDaren({ task_type }) {
			return task_type === 'task_type_anchor'; //达人交接
		},
		isHead({ task_type }) {
			return task_type === 'task_type_Institution'; //团长交接
		},
		isProduct({ task_type }) {
			return task_type === 'task_type_product';
		},
		emptyText({ isDaren, isHead }) {
			return `暂无待移交${isDaren ? '达人' : isHead ? '团长' : '商品'}`;
		},
		tableLabel({ isDaren, isHead, isProduct }) {
			const arr = [{ ...columns.descInfo }, columns.cooperate_count, columns.sample_count];
			if (isDaren) {
				arr[0].isDaren = true;
				arr.push(columns.cooperate_status_name);
			}
			if (isHead) {
				arr[0].isHead = true;
				arr.push(columns.authority_id);
			}
			if (isProduct) {
				arr[0].isProduct = true;
				arr.push(columns.shop_name);
			}
			arr.push(columns.status);
			return arr;
		},
		placeholder() {
			return ({ institution_name = '' }) => institution_name.charAt();
		},
	},
	data() {
		return {
			drawer: false,
			roleType: [],
			activeName: 'tobeHanded',
			tabArr: [
				{ label: '待交接', name: 'tobeHanded' },
				{ label: '已交接', name: 'Handover' },
			],
			selectList: [],
			task_type: 'task_type_anchor',
			loading: false,
			list: [],
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			total: 0,
			row: {},
			columns,
		};
	},

	props: {},

	mounted() {},

	methods: {
		show(row) {
			this.pageInfo = {
				page_index: 1,
				page_size: 10,
			};
			this.row = row;
			this.task_type = row.task_type;
			this.getList();
			this.drawer = true;
		},
		gePartnerList(val) {
			this.pageInfo.page_index = val.page_index;
			this.pageInfo.page_size = val.page_size;
			this.getList();
		},
		async getList() {
			const {
				row: { id: relay_task_id, task_type },
			} = this;
			this.loading = true;
			try {
				const {
					list = [],
					page: { item_total },
				} = await relayAnchorDetail({ relay_task_id, task_type, ...this.pageInfo });
				this.list = list;
				this.total = item_total;
				this.loading = false;
			} catch (e) {
				this.loading = false;
			}
		},
		handleClose() {
			this.task_type = 1;
			this.drawer = false;
		},
	},
};
</script>
<style lang="less" scoped>
.title-line {
	color: @color-gy9;
	font-size: 16px;
	position: relative;
	padding-left: 10px;

	&::before {
		position: absolute;
		content: ' ';
		width: 3px;
		height: 17px;
		background: @color-primary;
		left: 0px;
		top: 3px;
		border-radius: 100px;
	}
}
.handover {
	/deep/ .el-drawer__body {
		background-color: #f7f8fa;
	}
	/deep/ .el-drawer__header span {
		font-size: 14px;
	}
	.content {
		position: relative;
		padding: 20px 20px 60px 20px;
		background-color: #f7f8fa;
		.bgcf {
			padding: 20px;
			background-color: @color-white;
		}

		.nav {
			.pane {
				border: 1px solid #eaebf0;

				padding: 6px 27px;
			}
			.pane {
				border-width: 1px 0 1px 1px;
			}
			.pane:last-child {
				border-width: 1px;
			}
		}
	}

	.footer {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		border-top: 1px solid #f0f1f5;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.06);
		z-index: 999;
	}
}
</style>
